import { render } from "./CommonPageShell.vue?vue&type=template&id=1891ba2c&scoped=true"
import script from "./CommonPageShell.vue?vue&type=script&lang=js"
export * from "./CommonPageShell.vue?vue&type=script&lang=js"

import "./CommonPageShell.vue?vue&type=style&index=0&id=1891ba2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1891ba2c"]])

export default __exports__